import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { ButtonModule } from 'primeng/button';
import { PwaHandshakeService } from '../pwa-handshake.service';

@Component({
  selector: 'app-error',
  standalone: true,
  imports: [CommonModule,ButtonModule],
  templateUrl: './error.component.html',
  styleUrl: './error.component.css'
})
export class ErrorComponent {
  constructor(private router:Router,
    private pwaHandshakeService:PwaHandshakeService
  ) {}
  retry() {
    this.router.navigate(['/unavailable']);
    console.log('Retry clicked');
  }

  done() {
    this.pwaHandshakeService.done();
  }
}
